import React, {useEffect, useState} from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Checkbox from './checkbox-square'
import CountDown from '../../../components/count-down';
// import {CheckInData} from './checkInData.jsx'
// import Cache from "../../../../utils/cache";
import {checkIn, getSignIn} from "../../../../api";
import {useDispatch, useSelector} from "react-redux";
import {Iconfont} from "../../../components/icon/iconfont";
import {SET_SHOW_CHECK_IN} from "../../../../store/actions/global";
import ReactDOM from "react-dom";
import {BlackMask} from "../../../components/mask";


const getDayMsg =day=>{
    switch (day) {
        case 1:
            return "1st day"
        case 2:
            return "2nd day"
        case 3:
            return "3rd day"
    }
}
const CountDownPart = props => {
    useStyles(cls)
    // const {date} = props
    const now = new Date();
    const date = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime()+3 * 24 * 60 * 60 * 1000;

    const diff = date - now;
    return <div className={cls.CountDownBox}>
        <span className={cls.Expiresin}>Ends in</span>
        <CountDown
            showDay={true}
            showHour={true}
            offset={diff}
            numberClass={cls.numberClass}
        />
    </div>
}
const CouponContent=props=>{
    const {dailySignIn}=props
    const dayMsg=getDayMsg(dailySignIn.dateIndex)
    const {signIn}=dailySignIn
    return <div className={`${cls.CouponContent} ${signIn?cls.Checked:cls.UnChecked}`}>
        <div className={`${cls.DayMsg} ${signIn?cls.Checked:cls.UnChecked}`}><span >{dayMsg}</span></div>

    </div>
}
const CouponContentInfo=props=>{
    const {dailySignIn}=props
    const dayMsg=getDayMsg(dailySignIn.dateIndex)
    return <div className={cls.CouponContentInfo}>
        <div className={cls.Polygon}><span >Extra</span></div>
        <div className={cls.DayMsg}><span >{dayMsg}</span></div>
        <div className={cls.Msg1}><span >20%</span></div>
        <div className={cls.Msg2}><span >COUPON</span></div>
        <div className={cls.Msg3}><span >NO MINIMUM!</span></div>
    </div>
}
const CouponBox=props=>{
    const {dailySignIns}=props
    return <div className={cls.CouponBox}>
        {
            dailySignIns?.map((dailySignIn, index) =>{
                return dailySignIn.dateIndex==3?<CouponContentInfo key={index} dailySignIn={dailySignIn}/>:<CouponContent key={index} dailySignIn={dailySignIn}/>
            })
        }
    </div>
}
const BottomDiv=props=>{
    const {checkInData,handleCheckInClick,handleRemindClick,remind}=props
    const {dailySignIns}=checkInData
    const signedCount = Array.isArray(dailySignIns)? dailySignIns.filter(item => item.signIn).length: 0
    return <>
        <div className={cls.BottomDiv}>
            <CouponBox dailySignIns={dailySignIns}/>
            <div className={cls.CheckInDayMsg}><span>You've checked in for {signedCount} day</span></div>
            <div  className={cls.CheckinButtonDiv}>
                <div className={cls.CheckinButton} onClick={handleCheckInClick}>Check In Now</div>
            </div>
            <div className={cls.remindDiv}>
                <Checkbox selected={remind} onClick={handleRemindClick}/><span className={cls.remindMsg}>Don’t let deals slip away, enable email notifications now!</span>
            </div>
        </div>
    </>
}
const CheckedBottomDiv=props=>{
    const {handleClose}=props
    // const {dailySignIns}=checkInData
    const handleClick=()=>{
        handleClose();
    }
    return <>
        <div className={cls.CheckedBottomDiv}>
            <div className={cls.CouponDiv}>
                <span className={cls.CouponTag}>NO MINIMUM!</span>
                <div className={cls.CouponMsg1}>
                    <span>EXTRA</span>
                </div>
                <div className={cls.CouponMsg}>
                    <span>20% OFF</span>
                </div>
            </div>
            <CountDownPart/>
            <div className={cls.GoShopping} onClick={handleClick}>
                <span>Go Shopping</span>
            </div>
        </div>
    </>
}
const CheckInMain =props=>{
    const {checkInData,handleClose}=props
    console.log("@checkInData",checkInData)
    const {title,ruleDescription,dailySignIns}=checkInData
    const checked = dailySignIns.every(item => item.signIn)
    return <>
        <div className={cls.Main}>
            <Iconfont className={cls.Close} onClick={handleClose} >&#xe7c9;</Iconfont>
            <div className={cls.TopDiv}>
                <div>
                    <span className={cls.TitleName}>{title}</span>
                    <span className={checked?cls.CheckedSubTitleName:cls.SubTitleName}>{ruleDescription}</span>
                </div>
            </div>
            {checked?<CheckedBottomDiv {...props} handleClose={handleClose}/>:<BottomDiv {...props}/>}
        </div>
    </>
}
export default props =>{
    useStyles(cls)
    // const data=CheckInData()
    // console.log("@data",data)
    const [checkInData, setCheckInData] = useState(null)
    const [show, setShow] = useState(false);
    const [remind, setRemind] = useState(false);
    const showCheckIn = useSelector(state=>state.global.showCheckIn);
    const dispatch = useDispatch()
    console.log("@showCheckIn",showCheckIn)
    const getSignInData =async()=>{
        console.log("进入getSignInData")
        const response =await getSignIn()
        console.log("@response",response)
        if (response?.code === 200 && response?.result?.dailySignIns?.length > 0){
            console.log("@response?.result",response?.result)
            setCheckInData(response?.result)
            setShow(true);
            console.log("@checkInData",checkInData)
        }
    }
    const handleCheckInClick = async() => {
        console.log('parent clicked')
        const response =await checkIn()
        if (response?.code === 200 && response?.result?.dailySignIns?.length > 0){
            const checkInData=response?.result
            if( checkInData.dailySignIns.every(item => item.signIn)){
                checkInData.title="Congratulations !"
                checkInData.ruleDescription="The coupon has been added to your account"
            }
            setCheckInData({...checkInData})
        }
    }
    const handleClose = () => {
        dispatch({
            type:SET_SHOW_CHECK_IN,
            payload:false
        })
    }
    const handleRemindClick=()=>{
        setRemind(!remind)
    }

    useEffect(async () => {
        try {
            getSignInData()
        } catch (error) {
            console.log('error', error)
        }
    }, [])
    return<React.Fragment>
        {checkInData&&showCheckIn&&show&&ReactDOM.createPortal(<React.Fragment>
                <CheckInMain checkInData={checkInData} handleCheckInClick={handleCheckInClick}  handleClose={handleClose}
                handleRemindClick={handleRemindClick} remind={remind}/>
                <BlackMask style={{ zIndex: 6 }} onClick={handleClose} />
        </React.Fragment>, typeof document !== 'undefined' ? document.getElementById('root') : null)}
        {/*{checkInData&&showCheckIn&&show&&<div>1234566</div>}*/}
    </React.Fragment>
}